import { render } from "./ConfirmCodeDialog.vue?vue&type=template&id=52e1e33b"
import script from "./confirm-code-dialog-component.ts?vue&type=script&lang=js&external"
export * from "./confirm-code-dialog-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__